// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"1dffcf66","586":"f91a3d36"}[chunkId] + ".chunk.js";
};